import React from 'react'

import { HTLabel } from '../../atoms/fields/vat-label/ht'
import { TTCLabel } from '../../atoms/fields/vat-label/ttc'
import { HousePriceTypeEnum } from '../../../lib/graphql'

export const TaxLabel = ({
  className,
  housePricingType,
}: {
  housePricingType: HousePriceTypeEnum
  className?: string
}) => {
  return housePricingType === HousePriceTypeEnum.GLOBAL ? (
    <TTCLabel className={className} />
  ) : (
    <HTLabel className={className} />
  )
}
